import React from 'react';
import './styles.less';

import bottom1 from 'assets/ttu/bottom-1.gif';
import bottom2 from 'assets/ttu/bottom-4-2.avif';
import bottom3 from 'assets/ttu/bottom-3.gif';
import bottom5 from 'assets/ttu/bottom-5.avif';
import bottom6 from 'assets/ttu/bottom-6.gif';
import bottom7 from 'assets/ttu/bottom-7.gif';
import bottom8 from 'assets/ttu/bottom-8.avif';
import bottom9 from 'assets/ttu/bottom-9.avif';
import bottom10 from 'assets/ttu/bottom-10.avif';

export function WereAvailableDecoration() {
  return (
    <div className="bottom-graphic-1 ">
      <svg
        className="svg tcentered"
        width="535"
        height="377"
        viewBox="0 0 535 377"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_17_990)">
          <path
            d="M74.9452 129.992C45.4132 134.5 12.238 146.479 2.57802 174.741C0.830016 179.856 -0.00718409 185.441 1.34522 190.676C3.36002 198.477 9.83682 204.292 16.4976 208.836C43.84 227.485 79.26 233.161 103.704 255.48C126.152 275.969 135.536 307.028 154.222 331.003C184.342 369.643 240.03 386.047 286.288 369.892C303.758 363.792 319.978 353.534 338.295 350.875C358.793 347.894 379.263 354.767 399.742 357.904C420.221 361.041 443.985 359.21 457.352 343.377C466.736 332.254 468.917 316.504 477.859 305.022C486.811 293.532 501.154 287.938 513.362 279.989C525.57 272.04 536.886 258.599 533.722 244.376C529.425 225.093 502.69 219.205 494.944 201.026C488.375 185.606 497.961 167.74 494.824 151.272C490.96 131.004 469.377 118.649 462.385 99.2277C456.184 82.0053 462.578 62.5013 458.061 44.7637C441.676 -19.5443 306.712 1.94688 257.887 15.3237C217.987 26.2533 202.384 53.6233 176.237 81.7845C144.46 116.008 121.433 122.89 74.9452 129.983V129.992Z"
            fill="#C5D3E0"
          />
        </g>
        <defs>
          <clipPath id="clip0_17_990">
            <rect
              width="533.582"
              height="375.222"
              fill="white"
              transform="translate(0.672852 0.833984)"
            />
          </clipPath>
        </defs>
      </svg>
      <img className="img tcentered" src={bottom1} />
    </div>
  );
}

export function Question2Decoration() {
  return (
    <div className="ttu-q2">
      <svg
        className="svg"
        width="307"
        height="252"
        viewBox="0 0 307 252"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M259.465 12.4722C263.485 12.453 267.661 12.4722 271.291 14.3606C280.59 19.203 281.763 33.36 279.347 44.3526C276.936 55.3388 272.284 66.5164 274.776 77.4834C277.68 90.2369 289.099 97.9949 296.475 108.349C314.434 133.569 306.413 170.324 294.576 199.582C286.195 220.304 274.538 242.009 254.97 249.231C243.801 253.352 231.644 252.063 219.94 250.526C169.85 243.935 120.172 233.568 71.3773 219.519C67.5729 218.422 63.6233 217.216 60.7018 214.332C57.5072 211.174 56.0145 206.472 54.9284 201.904C47.3022 169.909 52.4134 131.968 32.2821 107.373C19.5214 91.7872 -3.50245 79.3336 0.447148 58.8414C3.0957 45.099 17.0006 38.4256 29.0992 33.8768C53.0233 24.8875 76.9474 15.8918 100.871 6.90252C112.604 2.494 125.057 -1.97193 137.173 0.930924C137.179 0.930924 137.19 0.930924 137.196 0.930924C180.828 11.4131 213.11 12.6955 259.465 12.4722Z"
          fill="#C5D3E0"
        />
      </svg>
      <img className="img tcentered" src={bottom3} />
    </div>
  );
}

export function YoureNotAloneDecoration() {
  return (
    <div className="bottom-graphic-2 nodisplay">
      <div className="curve-decoration" />
      <img className="img tcentered" src={bottom2} />
    </div>
  );
}

export function Question3Decoration() {
  return (
    <div className="ttu-q3">
      <svg
        className="topright fullwidth"
        width="951"
        height="233"
        viewBox="0 0 951 233"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_0_1715)">
          <path
            d="M1043.55 -52.6293C841.5 -51.4793 639.48 -42.9893 438.05 -27.1193C440.87 -44.0893 408.9 -54.4193 391.77 -52.8393C273.77 -41.9493 113.99 -36.6493 0 -4.27927C257.61 -36.5793 537.24 154.501 790.77 210.401C873.77 228.701 958.66 235.071 1043.55 232.071V-52.6293Z"
            fill="#F3E4DE"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1715">
            <rect
              width="1043.55"
              height="285.79"
              fill="white"
              transform="translate(0 -53)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        className="svg tcentered"
        width="411"
        height="283"
        viewBox="0 0 411 283"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_773_537)">
          <path
            d="M234.843 7.87977C270.108 -5.6733 309.902 -1.5903 342.698 18.9489C351.103 24.2118 359.516 31.1358 363.106 41.615C366.071 50.2778 365.302 60.167 367.726 69.0704C373.981 92.0781 398.599 101.059 407.578 122.755C415.932 142.953 407.885 167.839 395.322 184.66C382.759 201.481 366.143 213.303 352.895 229.363C343.134 241.193 335.08 255.445 323.234 264.154C309.101 274.54 291.67 275.557 275.08 276.294C227.741 278.382 180.408 280.463 133.068 282.551C119.072 283.164 104.886 283.762 91.2412 280.005C76.3454 275.898 62.818 266.801 49.5187 257.82C26.5429 242.295 0.178736 219.101 3.89291 187.959C5.15704 177.394 9.90728 166.24 5.89987 156.692C3.8864 151.903 -0.270876 147.796 0.230864 142.471C0.647895 138.055 4.13401 135.105 7.30083 132.737C80.9523 77.7643 153.626 44.161 234.843 7.87977Z"
            fill="#D2CFCA"
          />
        </g>
        <defs>
          <clipPath id="clip0_773_537">
            <rect
              width="410.808"
              height="283"
              fill="white"
              transform="translate(0.192383)"
            />
          </clipPath>
        </defs>
      </svg>
      <img className="img tcentered" src={bottom5} />
    </div>
  );
}

export function Question4Decoration() {
  return (
    <div className="ttu-q4">
      <svg
        className="topleft halfwidth"
        width="813"
        height="209"
        viewBox="0 0 813 209"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_0_1734)">
          <path
            d="M0 -75.8698V208.84C100.06 205.3 200.1 188.74 296.99 163.29C476.08 116.25 645.95 39.7702 812.71 -40.7298C542.6 -65.6898 271.26 -77.4098 0 -75.8698Z"
            fill="#F3E4DE"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1734">
            <rect
              width="812.71"
              height="284.84"
              fill="white"
              transform="translate(0 -76)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        className="svg"
        width="418"
        height="365"
        viewBox="0 0 418 365"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M226.573 36.1963C266.481 44.2588 312.548 32.7365 345.17 57.1095C358.369 66.9714 367.192 81.4516 375.699 95.5687C402.701 140.392 430.628 193.617 411.933 242.494C406.529 256.627 397.482 269.176 392.465 283.448C384.63 305.712 385.911 333.028 368.435 348.882C356.169 360.011 338.3 361.749 321.773 362.668C277.056 365.147 232.223 365.649 187.46 364.158C128.771 362.212 65.659 354.983 21.93 315.767C13.3231 308.052 5.49592 298.885 2.16896 287.811C-0.362921 279.37 -0.123627 270.373 0.216016 261.561C2.73246 195.864 9.22427 130.321 19.6374 65.4114C43.7752 69.9447 68.9165 74.4471 92.5911 67.9291C135.556 56.1055 117.64 17.0671 139.678 2.77227C161.122 -11.1441 203.554 31.5472 226.58 36.1963H226.573Z"
          fill="#F3F4F3"
        />
      </svg>
      <img className="img tcentered" src={bottom6} />
    </div>
  );
}

export function Question5Decoration() {
  return (
    <div className="ttu-q2">
      <svg
        className="halfwidth topright"
        width="812"
        height="284"
        viewBox="0 0 812 284"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_0_1748)">
          <path
            d="M840.14 283.279C746.79 264.059 654.3 215.929 569.94 168.679C488.35 122.979 406.76 77.2693 325.17 31.5693C285.4 9.28925 245.15 -13.1907 201.26 -25.5307C153.33 -39.0007 27.87 -23.4007 -2.9979e-05 -59.6407C89.56 -131.591 241.78 -135.851 351.07 -128.341C477.22 -119.671 600.55 -88.2508 725.27 -67.3908C763.44 -61.0108 801.74 -55.6208 840.14 -51.0908L840.14 283.279Z"
            fill="#F6E9CF"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1748">
            <rect
              width="840.14"
              height="414.28"
              fill="white"
              transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 283.279)"
            />
          </clipPath>
        </defs>
      </svg>
      <img className="img tcentered" src={bottom7} />
    </div>
  );
}

export function Question6Decoration() {
  return (
    <div className="ttu-q6 nodisplay">
      <svg
        className="halfwidth topright"
        width="364"
        height="502"
        viewBox="0 0 364 502"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_0_1775)">
          <path
            d="M475.77 -161.88C349.76 -162.89 223.36 -157.22 97.4799 -151.53C78.7699 -150.68 58.3299 -149.14 44.7199 -136.28C14.6299 -107.86 33.1399 -50.5105 27.2699 -14.0505C20.3299 29.0495 -18.6001 93.7495 10.8999 138.79C20.0999 152.84 35.7699 160.94 50.0299 169.81C157.08 236.36 205.85 366.169 296.21 454.06C306.36 463.94 317.3 473.44 330.39 478.849C356.75 489.75 386.77 482.389 415.17 485.039C435.88 486.969 455.87 494.26 475.76 501.33V-161.88H475.77Z"
            fill="#F3E4DE"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1775">
            <rect
              width="475.77"
              height="663.33"
              fill="white"
              transform="translate(0 -162)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        className="svg"
        width="438"
        height="309"
        viewBox="0 0 438 309"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M60.9662 106.019C36.7243 109.72 9.49187 119.552 1.56229 142.751C0.127408 146.95 -0.559823 151.534 0.550319 155.831C2.2042 162.235 7.5208 167.008 12.9884 170.738C35.4329 186.046 64.5081 190.705 84.5737 209.026C103.001 225.844 110.704 251.339 126.042 271.019C150.767 302.736 196.479 316.201 234.45 302.94C248.792 297.933 262.106 289.513 277.142 287.33C293.968 284.884 310.771 290.525 327.581 293.1C344.392 295.675 363.899 294.172 374.872 281.176C382.575 272.046 384.365 259.117 391.705 249.692C399.053 240.26 410.827 235.669 420.849 229.144C430.87 222.619 440.159 211.586 437.561 199.911C434.034 184.082 412.088 179.249 405.729 164.327C400.337 151.67 408.206 137.004 405.631 123.487C402.459 106.85 384.742 96.708 379.003 80.7662C373.913 66.6292 379.162 50.6194 375.454 36.0596C362.003 -16.7275 251.216 0.913521 211.137 11.8938C178.384 20.8654 165.576 43.332 144.114 66.448C118.029 94.5407 99.1264 100.189 60.9662 106.012V106.019Z"
          fill="#C5D3E0"
        />
      </svg>
      <img className="img tcentered" src={bottom8} />
    </div>
  );
}

export function Question7Decoration() {
  return (
    <div className="ttu-q7">
      <svg
        className="halwidth topleft"
        width="558"
        height="571"
        viewBox="0 0 558 571"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M503.85 161.101C508.81 107.781 529.91 51.7009 507.99 2.85086C482.94 -52.9891 408.47 12.2808 348 2.85082C230.91 -15.3992 118.51 26.4509 0 25.5109V555.721C25.21 564.691 50.27 573.321 76.46 570.291C121.47 565.081 155.64 526.971 198.73 512.961C254.99 494.671 314.82 519.751 372.71 531.911C422.86 542.441 475.05 543.141 525.47 533.961C536.02 532.041 547.57 528.981 553.44 520.001C557.53 513.731 557.97 505.831 557.99 498.341C558.33 383.961 493.25 274.991 503.85 161.111V161.101Z"
          fill="#F3E4DE"
        />
      </svg>
      <svg
        className="svg"
        width="647"
        height="400"
        viewBox="0 0 647 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M321.057 52.5618C278.814 33.1438 231.561 24.9708 185.34 29.1043C168.606 30.598 151.222 34.0175 138.133 44.6706C118.676 60.4999 113.581 87.6682 106.665 111.924C90.3777 169.004 56.8273 220.926 11.6657 258.963C7.59394 262.392 3.27115 265.924 1.27244 270.885C-6.19251 289.448 20.8319 300.57 39.5082 307.325C71.0135 318.711 93.6779 345.982 119.252 367.777C144.826 389.572 180.087 407.026 210.923 393.931C222.906 388.839 232.965 379.529 245.403 375.706C256.977 372.155 269.462 373.724 281.306 376.223C311.779 382.648 340.997 394.964 371.88 398.91C402.762 402.855 437.549 396.561 457.378 372.305C462.668 365.832 466.888 358.139 473.898 353.629C481.762 348.585 491.635 348.481 500.931 347.918C548.166 345.071 594.276 325.719 629.62 293.919C635.087 289.006 640.404 283.651 643.565 276.981C655.353 252.143 633.116 224.505 631.944 196.98C630.829 170.854 649.022 146.561 646.781 120.511C645.154 101.562 633.06 85.4323 621.44 70.4766C597.046 39.0716 568.478 5.19587 529.239 0.564494C517.748 -0.788281 506.128 0.545706 494.638 1.88909C463.309 5.53406 423.26 3.5143 394.154 17.089C367.111 29.6961 354.849 67.9402 321.047 52.5618H321.057Z"
          fill="#D2CECA"
        />
      </svg>
      <img className="img tcentered" src={bottom9} />
    </div>
  );
}

export function Question8Decoration() {
  return (
    <div className="ttu-q8 nodisplay">
      <svg
        className="svg tcentered"
        width="326"
        height="212"
        viewBox="0 0 326 212"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_0_1811)">
          <path
            d="M269.975 7.73863C293.202 14.7188 316.825 28.9318 323.728 52.1476C327.186 63.777 325.988 76.2204 324.759 88.2876C321.092 124.261 315.424 164.138 287.38 187.015C266.388 204.138 237.69 207.456 210.708 210.095C186.357 212.475 160.469 214.59 138.636 203.559C126.202 197.275 115.804 187.002 102.548 182.711C81.9075 176.026 55.0743 183.691 40.892 167.289C28.7041 153.193 35.0944 130.797 27.284 113.884C19.3069 96.5873 -3.37111 84.1255 0.426047 65.4727C5.21108 41.9487 91.9283 25.6823 112.556 18.9488C163.111 2.4542 217.809 -7.94201 269.975 7.73863Z"
            fill="#F3F4F3"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1811">
            <rect width="326" height="212" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <img className="img tcentered" src={bottom10} />
    </div>
  );
}

export function Question9Decoration() {
  return (
    <svg
      className="fullwidth topleft"
      width="1159"
      height="359"
      viewBox="0 0 1159 359"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_0_1829)">
        <path
          d="M0 -170.611V357.259C10.21 357.869 20.45 358.129 30.71 357.969C108.51 356.779 184 331.839 255.89 302.069C461.82 216.789 649.04 90.3792 856.62 9.19919C990.02 -42.9708 1130.06 -75.7608 1269.54 -108.381C850.02 -173.941 425.15 -182.191 0 -170.611Z"
          fill="#F6E9CF"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_1829">
          <rect
            width="1269.54"
            height="533.02"
            fill="white"
            transform="translate(0 -175)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Question10Decoration() {
  return (
    <svg
      className="fullwidth topleft"
      width="1159"
      height="359"
      viewBox="0 0 1159 359"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_0_1829)">
        <path
          d="M0 -170.611V357.259C10.21 357.869 20.45 358.129 30.71 357.969C108.51 356.779 184 331.839 255.89 302.069C461.82 216.789 649.04 90.3792 856.62 9.19919C990.02 -42.9708 1130.06 -75.7608 1269.54 -108.381C850.02 -173.941 425.15 -182.191 0 -170.611Z"
          fill="#F6E9CF"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_1829">
          <rect
            width="1269.54"
            height="533.02"
            fill="white"
            transform="translate(0 -175)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}